const ls = window.localStorage;
// https://github.com/tsironis/lockr
export default {
  getItem(key) {
    try {
      return JSON.parse(ls.getItem(key));
    } catch (err) {
      return null;
    }
  },
  setItem(key, val) {
    ls.setItem(key, JSON.stringify(val));
  },
  clear() {
    ls.clear();
  },
  keys() {
    return ls.keys();
  },
  removeItem(key) {
    ls.removeItem(key);
  },
  setItemChild(key, keyChild, val) {
    try {
      let item = JSON.parse(ls.getItem(key));
      item[keyChild] = val;
      ls.setItem(key, JSON.stringify(item));
      return;
    } catch (err) {
      return null;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/LStorage.js